import TextList from "components/Admin/Aspirations/SchorVertical/List/TextList"
import React from "react"

const TextListPage = () => {
    return (
        <React.Fragment>
            <TextList />
        </React.Fragment>
    )
}
export default TextListPage
